import { Checkbox } from '@signavio/ui';
import ContextHelp from '../ContextHelp';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function LabeledCheckbox({
  indeterminate,
  label,
  readOnly,
  value,
  description,
  onChange
}) {
  return /*#__PURE__*/_jsxs(Checkbox, {
    "aria-label": label,
    indeterminate: indeterminate,
    disabled: readOnly,
    checked: value,
    onChange: onChange,
    children: [label, description && /*#__PURE__*/_jsx(ContextHelp, {
      children: description
    })]
  });
}
export default LabeledCheckbox;